<template>
  <div>
    <span>{{ status }}</span>
    <span v-if="picked.qty">
      <span></span>
      <span v-if="picked.cases > 0">{{ picked.cases }}c</span>
      <span v-if="picked.cases > 0 && picked.bottles > 0"> </span>
      <span v-if="picked.bottles > 0">{{ picked.bottles }}bt</span>
      <span v-if="picked.skus > 0">
        <span v-if="picked.cases > 0 || picked.bottles > 0"> </span>
        {{ picked.skus }}&nbsp;SKUs
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'tdPickStatus',
  props: ['row'],
  computed: {
    picked() {
      return {
        qty: this.row.picks.reduce((sum, pick) => sum + pick.qty, 0),
        cases: this.row.picks.filter((pick) => pick.type === 'CASE').length,
        bottles: this.row.picks.filter((pick) => pick.type === 'BOTTLE').length,
        skus: this.row.skus,
      };
    },
    remaining() {
      return {
        qty: this.row.qty - this.picked.qty,
        cases: this.row.cases - this.picked.cases,
        bottles: this.row.bottles - this.picked.bottles,
      };
    },
    status() {
      if (this.row.type === 'pickup' || this.row.type === 'crossdock_pickup') {
        return 'Fully picked';
      }
      if (this.remaining.qty === this.row.qty) {
        return 'Not picked';
      } else if (this.remaining.qty > 0) {
        return 'Partially picked';
      } else if (this.remaining.qty < 0) {
        return 'Overpicked';
      } else {
        return 'Fully picked';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdPickStatus.vue